var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expand"}},[(_vm.msg)?_c('div',{key:!!_vm.msg,staticClass:"alert",class:_vm.alert_class,attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.msg)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }